import {
    CLOSE_DIALOGS,
    CREATE_OPTICIAN,
    CREATE_OPTICIAN_FAILURE,
    CREATE_OPTICIAN_SUCCESS,
    DELETE_OPTICIAN,
    DELETE_OPTICIAN_FAILURE,
    DELETE_OPTICIAN_SUCCESS,
    LIST_OPTICIANS_FAILURE,
    LIST_OPTICIANS_SUCCESS,
    LOAD_OPTICIAN,
    LOAD_OPTICIAN_FAILURE,
    LOAD_OPTICIAN_SUCCESS,
    OPEN_CREATE_DIALOG,
    OPEN_PROFILE_DIALOG,
    OPEN_UPDATE_DIALOG,
    UPDATE_OPTICIAN,
    UPDATE_OPTICIAN_FAILURE,
    UPDATE_OPTICIAN_SUCCESS,
    SEARCH_LINKABLE_OPTICIANS_SUCCESS,
    SEARCH_LINKABLE_OPTICIANS_FAILURE,
    LINK_OPTICIAN,
    LINK_OPTICIAN_SUCCESS,
    LINK_OPTICIAN_FAILURE,
    OPEN_LINK_DIALOG,
    CLOSE_LINK_DIALOG,
} from './OpticianActionTypes'
import {errorMessage} from "../../../components/AjaxHelpers";

export const initialOpticianState = () => ({
    opticianList: null,
    opticianForm: {
        careUnitOrganizationIds: [],
        name: null,
        hsaId: null,
        organizationId: null,
        organizationEmail: null,
        streetAddress: null,
        zipCode: null,
        city: null,
        contactName: null,
        contactPhoneNumber: null,
    },
    createDialogOpen: false,
    updateDialogOpen: false,
    profileDialogOpen: false,
    linkDialogOpen: false,
    linkableOpticians: [],
    linkError: null,
    saveOpticianError: null,
    errorMessage: null,
    isLoading: null,
});

const opticians = (state = initialOpticianState(), action) => {
    switch (action.type) {
        case LIST_OPTICIANS_SUCCESS:
            return {
                ...state,
                createDialogOpen: false,
                updateDialogOpen: false,
                profileDialogOpen: false,
                opticianList: action.opticians,
                opticianName: null,
                errorMessage: null,
            }
        case LIST_OPTICIANS_FAILURE:
            return {
                ...state,
                createDialogOpen: false,
                updateDialogOpen: false,
                profileDialogOpen: false,
                errorMessage: action.errorMessage,
            }
        case LOAD_OPTICIAN:
            return {
                ...state,
                isLoading: true,
            }
        case LOAD_OPTICIAN_SUCCESS:
            return {
                ...state,
                opticianForm: action.optician,
                errorMessage: null,
                isLoading: false,
            }
        case LOAD_OPTICIAN_FAILURE:
            return {
                ...state,
                opticianForm: initialOpticianState().opticianForm,
                errorMessage: action.errorMessage,
                isLoading: false,
            }
        case OPEN_CREATE_DIALOG:
            return {
                ...state,
                createDialogOpen: true,
                updateDialogOpen: false,
                profileDialogOpen: false,
                opticianForm: initialOpticianState().opticianForm,
            }
        case OPEN_UPDATE_DIALOG:
            return {
                ...state,
                createDialogOpen: false,
                updateDialogOpen: true,
                profileDialogOpen: false,
                opticianForm: action.opticianForm,
            }
        case OPEN_PROFILE_DIALOG:
            return {
                ...state,
                createDialogOpen: false,
                updateDialogOpen: false,
                profileDialogOpen: true,
                opticianForm: initialOpticianState().opticianForm,
            }
        case CLOSE_DIALOGS:
            return {
                ...state,
                createDialogOpen: false,
                updateDialogOpen: false,
                profileDialogOpen: false,
                linkDialogOpen: false,
                linkableOpticians: [],
                linkError: null,
                saveOpticianError: null,
                opticianForm: initialOpticianState().opticianForm,
            }
        case CREATE_OPTICIAN:
            return {
                ...state,
                isLoading: true,
            }
        case CREATE_OPTICIAN_SUCCESS:
            return {
                ...state,
                createDialogOpen: false,
                saveOpticianError: null,
                isLoading: false,
            }
        case CREATE_OPTICIAN_FAILURE:
            return {
                ...state,
                createDialogOpen: true,
                saveOpticianError: errorMessage(action.error, "Något gick fel vid försök att skapa optiker"),
                isLoading: false,
            }
        case UPDATE_OPTICIAN:
            return {
                ...state,
                isLoading: true,
            }
        case UPDATE_OPTICIAN_SUCCESS:
            return {
                ...state,
                updateDialogOpen: false,
                saveOpticianError: null,
                isLoading: false,
            }
        case UPDATE_OPTICIAN_FAILURE:
            return {
                ...state,
                updateDialogOpen: true,
                saveOpticianError: errorMessage(action.error, "Något gick fel vid försök att uppdatera optiker"),
                isLoading: false,
            }
        case DELETE_OPTICIAN:
            return {
                ...state,
                isLoading: true,
                saveOpticianError: null,
            }
        case DELETE_OPTICIAN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                updateDialogOpen: false,
                saveOpticianError: null,
            }
        case DELETE_OPTICIAN_FAILURE:
            return {
                ...state,
                isLoading: false,
                saveOpticianError: errorMessage(action.error, "Något gick fel vid försök att ta bort optiker"),
            }
        case OPEN_LINK_DIALOG:
            return {
                ...state,
                linkDialogOpen: true,
                linkableOpticians: [],
                linkError: null,
            }
        case CLOSE_LINK_DIALOG:
            return {
                ...state,
                linkDialogOpen: false,
                linkableOpticians: [],
                linkError: null,
            }
        case SEARCH_LINKABLE_OPTICIANS_SUCCESS:
            return {
                ...state,
                linkableOpticians: action.opticians,
            }
        case SEARCH_LINKABLE_OPTICIANS_FAILURE:
            return {
                ...state,
                linkError: errorMessage(action.error, "Något gick fel vid sökning av optiker"),
            }
        case LINK_OPTICIAN:
            return {
                ...state,
                isLoading: true,
                linkError: null,
            }
        case LINK_OPTICIAN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                linkDialogOpen: false,
                linkableOpticians: [],
                linkError: null,
            }
        case LINK_OPTICIAN_FAILURE:
            return {
                ...state,
                isLoading: false,
                linkError: errorMessage(action.error, "Något gick fel vid koppling av optiker"),
            }
        default:
            return state;
    }
}
export default opticians;